<template>
  <div-box>
    <nav-bar left-arrow :title="$t('投资记录')" />
    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.data" :noToken="false"
      :url="'/api/v1/orders/orderList'" :data="{ type: 2 }">
      <div-padding padding="4vw">

        <div-height height='3vw' />
        <div-card bg='#212748' padding='3vw' margin="0 0 3vw 0" v-for="(item, index) in list" :key="index">
          <div-flex>
            <div-text color='#fff' size='4vw'>{{ $t('投资') }}</div-text>
            <div-text color='#fff' size='4vw'>+{{ item.amount }} USDT</div-text>
          </div-flex>
          <van-divider style="margin:3vw 0" />


          <div-flex>
            <div-text color='#999' size='3.5vw'>
              {{ $t('时间') }}：{{ item.created_at }}</div-text>
            <div-text color='#20c595' size='3.5vw'>
              {{ $t('通过') }}
            </div-text>
          </div-flex>

        </div-card>
      </div-padding>
    </vant-up-down>
  </div-box>
</template>

<script>
export default {
  data() {
    return {
      list: [],
    }
  },
  created() {
    this.up_down()
  },
  methods: {
  },
}
</script>
<style lang='less' scoped></style>